import React, {ReactNode} from 'react';
import {Card, CardBody} from 'reactstrap';

interface IProps {
  children: ReactNode
  isLoading: boolean
  title: string
  actions?: ReactNode
  disableCardBackgroundColor?: boolean
}
export const CardComponent = (props: IProps) => {
  const {title, isLoading, actions, disableCardBackgroundColor} = props;
  const styles = {backgroundColor: 'white'}
  if (disableCardBackgroundColor) {
    styles.backgroundColor = 'transparent';
  }
  return (
    <Card style={styles}>
      <CardBody>
        <span className="card-title">
          {title.length > 0 &&
            <span>{title}&nbsp;&nbsp;</span>
          }
          {(title.length > 0 && isLoading) &&
            <i className="fa fa-cog fa-spin" />
          }
        </span>
        {props.children}
      </CardBody>
      {(!isLoading && actions) && // don't show actions when data is loading
        <div className="card-action">
          {actions}
        </div>
      }
    </Card>
  );
};
